var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"outline":"","small":"","color":_vm.getActHistoryStepColor(_vm.step)}},[_vm._v(_vm._s(_vm.translateActHistoryStep(_vm.step)))])}
var staticRenderFns = []

export { render, staticRenderFns }